const DEFAULT_FONTS = {
  rubik_Regular: require('../../assets/fonts/Rubik-Regular.ttf'),
  rubik_Medium: require('../../assets/fonts/Rubik-Medium.ttf'),
  rubik_Bold: require('../../assets/fonts/Rubik-Bold.ttf'),
  Quicksand_Bold: require('../../assets/fonts/Quicksand-Bold.ttf'),
  Quicksand_Light: require('../../assets/fonts/Quicksand-Light.ttf'),
  Quicksand_Medium: require('../../assets/fonts/Quicksand-Medium.ttf'),
  Quicksand_Regular: require('../../assets/fonts/Quicksand-Regular.ttf'),
  Quicksand_SemiBold: require('../../assets/fonts/Quicksand-SemiBold.ttf'),
  SF_Regular: require('../../assets/fonts/SF-Pro-Text-Regular.ttf'),
  SF_Medium: require('../../assets/fonts/SF-Pro-Text-Medium.ttf'),
  SF_Bold: require('../../assets/fonts/SF-Pro-Text-Bold.ttf'),
};

export const getDefaultFontsByKey = (imageKey) => DEFAULT_FONTS[imageKey];

// AdminScreen.js
export const font_rubik_Regular = getDefaultFontsByKey('rubik_Regular');
export const font_rubik_Medium = getDefaultFontsByKey('rubik_Medium');
export const font_rubik_Bold = getDefaultFontsByKey('rubik_Bold');
export const font_Quicksand_Bold = getDefaultFontsByKey('Quicksand_Bold');
export const font_Quicksand_Light = getDefaultFontsByKey('Quicksand_Light');
export const font_Quicksand_Medium = getDefaultFontsByKey('Quicksand_Medium');
export const font_Quicksand_Regular = getDefaultFontsByKey('Quicksand_Regular');
export const font_Quicksand_SemiBold = getDefaultFontsByKey('Quicksand_SemiBold');

// MainScreen.js
export const font_SF_Regular = getDefaultFontsByKey('SF_Regular');
export const font_SF_Medium = getDefaultFontsByKey('SF_Medium');
export const font_SF_Bold = getDefaultFontsByKey('SF_Bold');
